import AnalyticsAPIService from '@/modules/intelligence/services/apiService'

import ReportView  from '@/modules/reporting/views/report.vue'

export default class IntelligenceModule {
  constructor() {
  }

  install(Vue) {
    // Services
    Vue.prototype.$apiService.analyticsService = new AnalyticsAPIService(Vue.prototype.$api, Vue.prototype.$reportingApi)
  }

  getRoutes() {
    return [
      {
        path: '/analytics',
        name: 'IntelligenceDashboard',
        component: () => import('@/modules/intelligence/views/dashboard.vue'),
        meta: {
          requiresAuth: true,
          title: 'Analytics Dashboard',
          menuLink: '/analytics',
          breadcrumbs: [
            { title: 'Home', link: '/'},
          ]
        }
      },

      // Contact Reports
      {
        path: '/analytics/reports/contacts/people',
        name: 'IntelligenceContactPeople',
        component: () => import('@/modules/intelligence/reportViews/contacts/contactsPeople.vue'),
        meta: {
          requiresAuth: true,
          title: 'Contacts Report - People List',
          menuLink: '/analytics',
          breadcrumbs: [
            { title: 'Home', link: '/'},
            { title: 'Analytics', link: '/analytics'},
          ]
        }
      },

      // Inventory Reports
      {
        path: '/analytics/reports/inventory/stockvalueonhand',
        name: 'IntelligenceInventoryStockValueOnHand',
        component: () => import('@/modules/intelligence/reportViews/inventory/stockValueOnHand.vue'),
        meta: {
          requiresAuth: true,
          title: 'Inventory Report - Stock Value On Hand',
          menuLink: '/analytics',
          breadcrumbs: [
            { title: 'Home', link: '/'},
            { title: 'Analytics', link: '/analytics'},
          ]
        }
      },
      {
        path: '/analytics/reports/inventory/inventoryvaluegroups',
        name: 'IntelligenceInventoryGroups',
        component: () => import('@/modules/intelligence/reportViews/inventory/inventoryGroups.vue'),
        meta: {
          requiresAuth: true,
          title: 'Inventory Report - Summary',
          menuLink: '/analytics',
          breadcrumbs: [
            { title: 'Home', link: '/'},
            { title: 'Analytics', link: '/analytics'},
          ]
        }
      },
      {
        path: '/analytics/reports/inventory/salespricing/report',
        name: 'IntelligenceInventorySalesPricingReport',
        // JB: Not lazy-loaded to avoid flicker with layout issue
        component: ReportView,
        meta: {
          requiresAuth: true,
          title: 'Inventory Sales Pricing Report',
          layout: 'Blank',
          report: {
            url: '/reporting/inventory/salespricingreport'
          },
        }
      },
      {
        path: '/analytics/reports/inventory/salespricing/export',
        name: 'IntelligenceInventorySalesPricingExport',
        // JB: Not lazy-loaded to avoid flicker with layout issue
        component: ReportView,
        meta: {
          requiresAuth: true,
          title: 'Inventory Sales Pricing Export',
          layout: 'Blank',
          report: {
            url: '/reporting/inventory/salespricingexport',
            options: ['stockType']
          },
        }
      },

      // Purchasing Reports
      {
        path: '/analytics/reports/purchasing/purchasingreports',
        name: 'IntelligenceStockPurchasingReport',
        component: () => import('@/modules/intelligence/reportViews/purchasing/stockPurchasingReport.vue'),
        meta: {
          requiresAuth: true,
          title: 'Purchasing Report - Stock Purchasing',
          menuLink: '/analytics',
          breadcrumbs: [
            { title: 'Home', link: '/'},
            { title: 'Analytics', link: '/analytics'},
          ]
        }
      },

      // Orders Reports
      {
        path: '/analytics/reports/orders/ordervaluegroups',
        name: 'IntelligenceOrderValueGroups',
        component: () => import('@/modules/intelligence/reportViews/orders/orderValueGroups.vue'),
        meta: {
          requiresAuth: true,
          title: 'Orders Report - Order Value Summary',
          menuLink: '/analytics',
          breadcrumbs: [
            { title: 'Home', link: '/'},
            { title: 'Analytics', link: '/analytics'},
          ]
        }
      },
      {
        path: '/analytics/reports/orders/orderitems',
        name: 'IntelligenceOrderItems',
        component: () => import('@/modules/intelligence/reportViews/orders/orderItems.vue'),
        meta: {
          requiresAuth: true,
          title: 'Orders Report - Order Items Report',
          menuLink: '/analytics',
          breadcrumbs: [
            { title: 'Home', link: '/'},
            { title: 'Analytics', link: '/analytics'},
          ]
        }
      },
      {
        path: '/analytics/reports/orders/ncrvalue',
        name: 'IntelligenceNCROrderValue',
        component: () => import('@/modules/intelligence/reportViews/orders/ncrValue.vue'),
        meta: {
          requiresAuth: true,
          title: 'Orders Report - NCR Value',
          menuLink: '/analytics',
          breadcrumbs: [
            { title: 'Home', link: '/'},
            { title: 'Analytics', link: '/analytics'},
          ]
        }
      },
      {
        path: '/analytics/reports/orders/detailedsummary/glass',
        name: 'IntelligenceOrderGlassDetailedValue',
        component: () => import('@/modules/intelligence/reportViews/orders/salesGlassDetailedSummary.vue'),
        meta: {
          requiresAuth: true,
          title: 'Orders Report - Glass Detailed Summary',
          menuLink: '/analytics',
          breadcrumbs: [
            { title: 'Home', link: '/'},
            { title: 'Analytics', link: '/analytics'},
          ]
        }
      },
      {
        path: '/analytics/reports/orders/detailedsummary/services',
        name: 'IntelligenceOrderServicesDetailedValue',
        component: () => import('@/modules/intelligence/reportViews/orders/salesServicesDetailedSummary.vue'),
        meta: {
          requiresAuth: true,
          title: 'Orders Report - Services Detailed Summary',
          menuLink: '/analytics',
          breadcrumbs: [
            { title: 'Home', link: '/'},
            { title: 'Analytics', link: '/analytics'},
          ]
        }
      },

      // Production Reports
      {
        path: '/analytics/reports/production/recutvalue',
        name: 'IntelligenceRecutProductionValue',
        component: () => import('@/modules/intelligence/reportViews/production/recutValue.vue'),
        meta: {
          requiresAuth: true,
          title: 'Production Report - Recut Value',
          menuLink: '/analytics',
          breadcrumbs: [
            { title: 'Home', link: '/'},
            { title: 'Analytics', link: '/analytics'},
          ]
        }
      },
      {
        path: '/analytics/reports/production/performance',
        name: 'IntelligencePerformanceProduction',
        component: () => import('@/modules/intelligence/reportViews/production/performance.vue'),
        meta: {
          requiresAuth: true,
          title: 'Production Report - Performance',
          menuLink: '/analytics',
          breadcrumbs: [
            { title: 'Home', link: '/'},
            { title: 'Analytics', link: '/analytics'},
          ]
        }
      },
      {
        path: '/analytics/reports/production/despatch',
        name: 'IntelligenceDespatchProduction',
        component: () => import('@/modules/intelligence/reportViews/production/despatch.vue'),
        meta: {
          requiresAuth: true,
          title: 'Production Report - Despatch',
          menuLink: '/analytics',
          breadcrumbs: [
            { title: 'Home', link: '/'},
            { title: 'Analytics', link: '/analytics'},
          ]
        }
      },
      {
        path: '/analytics/reports/production/optimiser',
        name: 'IntelligenceOptimiserProduction',
        component: () => import('@/modules/intelligence/reportViews/production/optimiser.vue'),
        meta: {
          requiresAuth: true,
          title: 'Production Report - Optimiser',
          menuLink: '/analytics',
          breadcrumbs: [
            { title: 'Home', link: '/'},
            { title: 'Analytics', link: '/analytics'},
          ]
        }
      },

      // Accounts
      {
        path: '/analytics/reports/accounts/agedtrialbalance',
        name: 'IntelligenceAgedTrialBalance',
        component: () => import('@/modules/intelligence/reportViews/accounts/agedTrialBalance.vue'),
        meta: {
          requiresAuth: true,
          title: 'Accounts Report - Aged Receivables',
          menuLink: '/analytics',
          breadcrumbs: [
            { title: 'Home', link: '/'},
            { title: 'Analytics', link: '/analytics'},
          ]
        }
      },
      {
        path: '/analytics/reports/accounts/:id/balance/report',
        name: 'IntelligenceAccountsCustomerBalanceReport',
        // JB: Not lazy-loaded to avoid flicker with layout issue
        component: ReportView,
        meta: {
          requiresAuth: true,
          title: 'Customer Balance Statement Report',
          layout: 'Blank',
          report: {
            variables: ['id'],
            options: ['date'],
            url: '/reporting/contacts/:id/balance/report'
          },
        }
      },
      {
        path: '/analytics/reports/accounts/invoicevaluegroups',
        name: 'IntelligenceInvoiceValueGroups',
        component: () => import('@/modules/intelligence/reportViews/accounts/invoiceValueGroups.vue'),
        meta: {
          requiresAuth: true,
          title: 'Accounts Report - Invoice Value Summary',
          menuLink: '/analytics',
          breadcrumbs: [
            { title: 'Home', link: '/'},
            { title: 'Analytics', link: '/analytics'},
          ]
        }
      },
      {
        path: '/analytics/reports/accounts/detailedsummary/glass',
        name: 'IntelligenceInvoiceGlassDetailedValue',
        component: () => import('@/modules/intelligence/reportViews/accounts/invoiceGlassDetailedSummary.vue'),
        meta: {
          requiresAuth: true,
          title: 'Accounts Report - Glass Detailed Summary',
          menuLink: '/analytics',
          breadcrumbs: [
            { title: 'Home', link: '/'},
            { title: 'Analytics', link: '/analytics'},
          ]
        }
      },
      {
        path: '/analytics/reports/accounts/detailedsummary/services',
        name: 'IntelligenceInvoiceServicesDetailedValue',
        component: () => import('@/modules/intelligence/reportViews/accounts/invoiceServicesDetailedSummary.vue'),
        meta: {
          requiresAuth: true,
          title: 'Accounts Report - Services Detailed Summary',
          menuLink: '/analytics',
          breadcrumbs: [
            { title: 'Home', link: '/'},
            { title: 'Analytics', link: '/analytics'},
          ]
        }
      },

      // Pricing Reports
      {
        path: '/analytics/reports/pricing/customerpricing',
        name: 'IntelligenceCustomerPricing',
        component: () => import('@/modules/intelligence/reportViews/pricing/customerPricing.vue'),
        meta: {
          requiresAuth: true,
          title: 'Customer Pricing Report',
          menuLink: '/analytics',
          breadcrumbs: [
            { title: 'Home', link: '/'},
            { title: 'Analytics', link: '/analytics'},
          ]
        }
      },
    ]
  }
}
